export function SearchEmptyState({
  term,
  onClear,
  className,
}: {
  term?: string;
  onClear: () => void;
  className?: string;
}) {
  const label = term?.trim();
  return (
    <div className={className ?? 'px-6 py-12 text-center'}>
      <p className="text-sm text-dash-on-surface-variant">
        {label ? `No se encontraron resultados para «${label}».` : 'No se encontraron resultados.'}
      </p>
      <button
        type="button"
        className="mt-3 text-sm font-medium text-dash-secondary hover:underline"
        onClick={onClear}
      >
        Limpiar búsqueda
      </button>
    </div>
  );
}
